import axios from "axios";
import { getCookie } from "../utils/ReactCookie";
import { sendErrorLog } from "../utils/ErrorLogger";

const baseURL: string = process.env.REACT_APP_BASE_URL ?? "";

const DefaultClient = axios.create({
  baseURL,
});

DefaultClient.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};
    const token = getCookie('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
);

DefaultClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    if (url.includes('/log/client-error')) {
      return Promise.reject(error);
    }

    sendErrorLog({
      message: error.message || 'API Error',
      stack: error.stack,
      context: `axios:${error.config?.method?.toUpperCase()} ${url} ${status || 'NETWORK_ERROR'}`,
    });

    return Promise.reject(error);
  },
);

export default DefaultClient;
